module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post"
  }, [(_vm.hasDataLoadErr) ? _c('mu-toast', {
    attrs: {
      "message": "没有找到好电影"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasCopyErr) ? _c('mu-toast', {
    attrs: {
      "message": "复制地址失败"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasCopySuccess) ? _c('mu-toast', {
    attrs: {
      "message": "复制地址成功"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "loading"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "movies-wrapper"
  }, _vm._l((_vm.movieRows), function(cols, rowIndex) {
    return _c('mu-row', {
      key: rowIndex,
      staticClass: "movie-row",
      attrs: {
        "gutter": ""
      }
    }, _vm._l((cols), function(movie, colIndex) {
      return _c('mu-col', {
        key: colIndex,
        attrs: {
          "width": "100",
          "tablet": "50",
          "desktop": "25"
        }
      }, [_c('mu-card', [_c('mu-card-media', {
        attrs: {
          "title": movie.title,
          "subTitle": movie.type
        }
      }, [_c('img', {
        attrs: {
          "height": "500",
          "src": movie.poster
        }
      })]), _vm._v(" "), _c('mu-card-actions', [_c('mu-chip', [_vm._v(_vm._s(movie.year))]), _vm._v(" "), _c('mu-chip', [_vm._v(_vm._s(movie.tag))]), _vm._v(" "), _c('mu-chip', {
        attrs: {
          "backgroundColor": "yellow300"
        }
      }, [_vm._v(_vm._s(movie.score))]), _vm._v(" "), _c('mu-divider', {
        staticClass: "action-divider"
      }), _vm._v(" "), _c('mu-raised-button', {
        attrs: {
          "label": "原始详情页面",
          "target": "__blank",
          "a:href": "movie.link",
          "primary": ""
        }
      }), _vm._v(" "), _c('mu-raised-button', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (movie.paths.join('\n')),
          expression: "movie.paths.join('\\n')",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopySuccess),
          expression: "onCopySuccess",
          arg: "success"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:error",
          value: (_vm.onCopyError),
          expression: "onCopyError",
          arg: "error"
        }],
        attrs: {
          "label": "复制下载地址",
          "primary": ""
        }
      })], 1)], 1)], 1)
    }))
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc97d45a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/List.vue
// module id = 53
// module chunks = 1